export const ROW_HEIGHT = 40;

export const SELECTED_OPTION_PLACEHOLDER_CLASS = 'selected-option-placeholder';
